import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import MainGrid from './components/MainGrid';
import SideMenu from '../shared/components/SideMenu';
import AppTheme from '../shared-theme/AppTheme';
import {
  chartsCustomizations,
  dataGridCustomizations,
//   datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';
import { getStorage } from "firebase/storage";
import {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import { useAuth } from '../shared/context/AuthContext';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
//   ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function Dashboard(props) {
    const {page, setPage} = props
    const { auth, user, isAuthResolved } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
      if (location?.state?.page === 'Profile' && typeof setPage === 'function') {
        setPage('Profile');
      }
    }, [location?.state?.page, setPage]);

    useEffect(() => {
      if (!isAuthResolved) return;
      if (!user) {
        navigate('/login', { replace: true });
      }
    }, [isAuthResolved, user, navigate]);
    return (
        <AppTheme {...props} themeComponents={xThemeComponents}>
            <CssBaseline enableColorScheme/>
            <Box sx={{display: 'flex'}}>
                <SideMenu setPage={setPage} />
                {/* <AppNavbar setPage={setPage} /> */}
                <Box
                    component="main"
                    sx={(theme) => ({
                        flexGrow: 1,
                        backgroundColor: theme.vars
                            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                            : alpha(theme.palette.background.default, 1),
                        overflow: 'auto',
                        pt: 0,
                        pb: 0
                    })}
                >
                    <Stack
                        spacing={2}
                        sx={{
                            alignItems: 'center',
                            px: 0,
                            pb: 0,
                            mt: {xs: 8, md: 0},
                            width: '100%',
                            maxWidth: '100%'
                        }}
                    >
                        {/* <Header page={page}/> */}
                        <MainGrid auth={auth} page={page}/>
                    </Stack>
                </Box>
            </Box>
        </AppTheme>
    );
}